export { Heading } from "./Heading";
export type { HeadingProps } from "./Heading";
